module.exports = __webpack_public_path__ + "static/media/rollerblade1.6dddaf73.gif";